import Pusher from 'pusher-js'

const pusher = new Pusher(process.env.REACT_APP_PUSHER_API_KEY as string, {
  cluster: 'us2',
  // 没有 encrypted 属性
  // encrypted: true,
})

export default pusher
